import { FindCustomersGet, FindCustomersParams } from '@app/services/customer.service';

export function getFindCustomersParams(page: FindCustomersGet): FindCustomersParams {
    const lastCustomersSelected = page.show_last_visited_customers === '1';

    return {
        cust_name: lastCustomersSelected ? '' : page.cust_name,
        custgrp_id: lastCustomersSelected ? 'ALL' : page.custgrp_id,
        custtype: page.findcustomers_selection,
        lastselect: lastCustomersSelected ? 'LAST' : 'SEARCH',
    };
}
